import { useNavigate, useLocation } from "react-router-dom";

export default function useSiteNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const goHashSection = (id) => {
    if (location.pathname === "/") {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/", { state: { scrollTo: id } });
    }
  };

  const goRoute = (path) => navigate(path);

  const goTop = () => {
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
    }
  };

  return { goHashSection, goRoute, goTop, location };
}
